import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { InputWithLabel } from 'shared/ui/input-label'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface DatesCardProps {
  startDate?: string
  endDate?: string
  onSelect: () => void
}

export const DatesCard: FC<DatesCardProps> = ({
  startDate,
  endDate,
  onSelect,
}) => {
  const { t } = useTranslation()
  const formattedStartDate = startDate
    ? dateFormat(startDate, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR)
    : ''
  const formattedEndDate = endDate
    ? dateFormat(endDate, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR)
    : ''
  const datePeriod =
    formattedStartDate && formattedEndDate
      ? t('insurance.vzr.dates.period', {
          start: formattedStartDate,
          end: formattedEndDate,
        })
      : ''

  return (
    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <h2 className={clsx(s.title, 'bold-17')}>
        {t('insurance.vzr.dates.label')}
      </h2>
      <div
        className={s.field}
        onClick={onSelect}
      >
        <InputWithLabel
          readOnly
          containerClassName={s.fieldContainer}
          label={t('insurance.vzr.dates.placeholder')}
          placeholder={t('insurance.vzr.dates.placeholder')}
          value={datePeriod}
          rightIcon={
            <AppIcon
              id={AllIcons.CALENDAR_NEW}
              width={24}
              height={24}
            />
          }
        />
      </div>
    </Paper>
  )
}
